<template>
  <div>
    <div style="height:50px"></div>
    <div style="height:10px"></div>
    <div style="font-size: 25px;
    font-weight: bold;">
      云机械管理系统
    </div>
    <div style="height:20px"></div>
    <div style="width:500px;height:500px;margin-left: 34%;">
      <el-form style=""
               :label-position="labelPosition"
               label-width="80px"
               :model="formLabelAlign">
        <el-form-item label="账号">
          <el-input v-model="formLabelAlign.name"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="formLabelAlign.pass"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary"
                     @click="gotologin">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        pass: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    gotologin () {
      var name = this.formLabelAlign.name
      var pass = this.formLabelAlign.pass
      this.dataListLoading = true
      this.$http({
        url: this.global.apiUrl + '/jxjg/jguser/adminlogin',
        method: 'post',
        params: {
          'name': name,
          'pass': pass
        }
      }).then((data) => {
        data = data.body
        console.log(data)
        if (data.code === 0) {
          localStorage.setItem('phone', name)
          this.$router.push('/index')
        } else {
          this.$message({
            message: '登录失败',
            type: 'error',
            duration: 1500,
            onClose: () => {
            }
          })
        }
        this.dataListLoading = false
      })
    }
  }
}
</script>
.el-form-item {
  width: 100%;
  float: none;
}
<style>
</style>



// WEBPACK FOOTER //
// src/view/login.vue